var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('download-csv',{staticClass:"btn float-right btn-primary pad",attrs:{"data":_vm.data,"name":_vm.name}},[_c('img',{attrs:{"src":"download.svg"}}),_vm._v("Download ")])}
var staticRenderFns = []

export { render, staticRenderFns }